import { combineReducers } from 'redux';
import loadingReducer from './loading/reducer';
import authReducer from './auth/reducer';
import paginationReducer from './pagination/reducer';
import manageOrganizationsReducer from './manageOrganizations/reducer';
import curriculumTopicsReducer from './curriculumTopics/reducer';
import globalReducer from './global/reducer';
import SchoolClassesReducer from './schoolClasses/reducer';
import bookingReducer from './booking/reducer';
import slideReducer from './slides/reducer';
import contentTagsReducer from './contentTags/reducer';
import classCentricUIReducer from './classCentricUI/reducer';
import presentationReducer from './presentation/reducer';

export default (routerReducer) =>
  combineReducers({
    global: globalReducer,
    loading: loadingReducer,
    auth: authReducer,
    pagination: paginationReducer,
    manageOrganizations: manageOrganizationsReducer,
    curriculumTopics: curriculumTopicsReducer,
    schoolClasses: SchoolClassesReducer,
    booking: bookingReducer,
    router: routerReducer,
    slides: slideReducer,
    contentTags: contentTagsReducer,
    classCentricUI: classCentricUIReducer,
    presentation: presentationReducer,
  });
